import {
  GET_PAGINATED_EVENT_REPORTS,
  GETTING_PAGINATED_EVENT_REPORTS,
  GETTING_PAGINATED_EVENT_REPORTS_SUCCEEDED,
  GETTING_PAGINATED_EVENT_REPORTS_FAILED,
  CLEAR_EVENT_REPORTS_STORE,
  SET_CURRENT_EVENT,
  UNSET_CURRENT_EVENT,
  GET_PAGINATED_EVENT_HISTORY,
  GETTING_PAGINATED_EVENT_HISTORY_SUCCEEDED,
  GET_EVENT_REPORT_CSV_FILE,
  GETTING_EVENT_REPORT_CSV_FILE_SUCCEEDED,
  GETTING_EVENT_REPORT_CSV_FILE_FAILED,
  DOWNLOADED_EVENT_REPORT_CSV_FILE,
  RESET_SNACKBAR,
  UPDATE_EVENT_REPORT_FILTERS,
  UPDATE_EVENT_IDENTIFIER_FILTER,
  RESET_EVENT_REPORT_FILTERS,
  GET_EVENT_LOG,
  GETTING_EVENT_LOG_SUCCEEDED,
  GETTING_EVENT_LOG_FAILED
} from './actions';
import { createReducer } from '@reduxjs/toolkit';

const initialState = {
  gettingPaginated: true,
  paginatedList: [],
  current: {},
  filters: {
    searchInput: '',
    sortBy: 'createTime',
    sortOrder: 'DESC',
    rowsPerPage: 10,
    pageNo: 0,
    totalCount: 0,
    filterTypes: [],
    filterTemplates: [],
    filterProductNames: [],
    filterProductCategories: [],
    filterTags: [],
    filterPaginatedTemplates: [],
    filterPaginatedCampaigns: [],
    filterEventTypeCategories: [],
    filterStartDate: null,
    filterEndDate: null,
    filterEventIdentifierValues: [],
    searchScopes: null,
  },
  eventHistory: [],
  eventReportCsv: {
    getting: false,
    gettingFileSucceeded: false,
    eventReportCsvBlob: {},
    isDownloading: false
  },
  showSnackbar: false,
  gettingEventLog: false,
  eventLog: [],
  eventLogError: {}
};

export default createReducer(initialState, {
  [GET_PAGINATED_EVENT_REPORTS]: state => {
    state.error = {};
    return state;
  },
  [GETTING_PAGINATED_EVENT_REPORTS]: state => {
    state.gettingPaginated = true;
  },
  [GETTING_PAGINATED_EVENT_REPORTS_SUCCEEDED]: (state, action) => {
    state.gettingPaginated = false;
    state.paginatedList = action?.payload.map(template => ({
      ...template
    }));
    return state;
  },
  [GETTING_PAGINATED_EVENT_REPORTS_FAILED]: (state, action) => {
    state.gettingPaginated = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },

  [CLEAR_EVENT_REPORTS_STORE]: state => {
    let updatedState = {
      ...initialState
    };
    return updatedState;
  },

  [SET_CURRENT_EVENT]: (state, action) => {
    state.current = {
      ...action.payload,
    };
    return state;
  },

  [UNSET_CURRENT_EVENT]: state => {
    state.current = { ...initialState.current };
    return state;
  },
  
  [GET_PAGINATED_EVENT_HISTORY]: (state, action) => {
    state.gettingPaginated = true;
    state.eventHistory = [];
    return state;
  },

  [GETTING_PAGINATED_EVENT_HISTORY_SUCCEEDED]: (state, action) => {
    state.gettingPaginated = false;
    state.eventHistory = action?.payload.map(template => ({
      ...template
    }));
    return state;
  },
  [GET_EVENT_REPORT_CSV_FILE]: (state) => {
    state.eventReportCsv = {
      getting: true,
      isDownloading: true,
      gettingFileSucceeded: false,
      eventReportCsvBlob: {}
    };
    state.error = {};
    state.showSnackbar = false;
    return state;
  },
  [GETTING_EVENT_REPORT_CSV_FILE_SUCCEEDED]: (state, action) => {
    state.eventReportCsv = {
      getting: false,
      gettingFileSucceeded: true,
      eventReportCsvBlob: action.payload
    };
    state.showSnackbar = true;
    return state;
  },
  [GETTING_EVENT_REPORT_CSV_FILE_FAILED]: (state, action) => {
    state.eventReportCsv = {
      getting: false,
      gettingFileSucceeded: false,
      eventReportCsvBlob: {}
    };
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    state.showSnackbar = true;
    return state;
  },
  [DOWNLOADED_EVENT_REPORT_CSV_FILE]: state => {
    state.eventReportCsv = {
      ...state.eventReportCsv,
      isDownloading: false,
      gettingFileSucceeded: false,
      eventReportCsvBlob: {}
    };
    return state;
  },
  [RESET_SNACKBAR]: state => {
    state.showSnackbar = false;
    return state;
  },
  [UPDATE_EVENT_REPORT_FILTERS]: (state, action) => {
    state.gettingPaginated = true;
    if (action.payload.filterProductNames) {
      state.filters.filterEventIdentifierValues = [];
    }
    state.filters = {
      ...state.filters,
      ...action.payload
    }
    return state;
  },
  [UPDATE_EVENT_IDENTIFIER_FILTER]: (state, action) => {
    state.filters = {
      ...state.filters,
      filterEventIdentifierValues: action.payload,
      pageNo: 0,
    }
  },
  [RESET_EVENT_REPORT_FILTERS]: state => {
    state.gettingPaginated = true;
    state.filters = { ...initialState.filters }
    return state;
  },
  [GET_EVENT_LOG]: (state, action) => {
    state.gettingEventLog = true;
    state.eventLogError = {};
    state.eventLog = [];
    return state;
  },
  [GETTING_EVENT_LOG_SUCCEEDED]: (state, action) => {
    state.gettingEventLog = false;
    state.eventLogError = {};
    state.eventLog = action.payload;
    return state;
  },
  [GETTING_EVENT_LOG_FAILED]: (state, action) => {
    state.gettingEventLog = false;
    if (action.payload?.response?.data) {
      state.eventLogError = {
        message: action.payload.response.data.message,
        raw: action.payload.response.data
      };
    } else if (action.payload?.message) {
      state.eventLogError = {
        message: action.payload.message,
        raw: action.payload
      };
    }
    state.eventLog = [];
    return state;
  }
});
